<template>
  <div class="app-wrapper-div">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'app-wrapper-div'
}
</script>
